import { SearchFormState } from '../reducers';
import { createSelector } from 'reselect';

export const getIsForeignCard = (state: SearchFormState) => state.foreignCard;

export const getModifiedEngineURL = createSelector(
	getIsForeignCard,
	(_state: SearchFormState, engineURL: string) => engineURL,
	(_state: SearchFormState, _engineURL: string, iataCode: string) => iataCode,
	(isForeignCard, engineURL, iataCode) => {
		if (iataCode === 'WZ' && isForeignCard) {
			return engineURL.replace('.com', '.kz');
		}

		return engineURL;
	}
);
